/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Vector3dPb } from "../eigen_lcm/Vector3d";
import { Uuid } from "../uuid_util/uuid";

export const protobufPackage = "planner";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface MovementWaypoint {
  speed: number;
  maxPathSpeed: number;
  position: Vector3dPb | undefined;
  uuid: Uuid | undefined;
}

function createBaseMovementWaypoint(): MovementWaypoint {
  return { speed: 0, maxPathSpeed: 0, position: undefined, uuid: undefined };
}

export const MovementWaypoint = {
  encode(message: MovementWaypoint, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.speed !== 0) {
      writer.uint32(9).double(message.speed);
    }
    if (message.maxPathSpeed !== 0) {
      writer.uint32(17).double(message.maxPathSpeed);
    }
    if (message.position !== undefined) {
      Vector3dPb.encode(message.position, writer.uint32(26).fork()).ldelim();
    }
    if (message.uuid !== undefined) {
      Uuid.encode(message.uuid, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MovementWaypoint {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMovementWaypoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 9) {
            break;
          }

          message.speed = reader.double();
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.maxPathSpeed = reader.double();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.position = Vector3dPb.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.uuid = Uuid.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MovementWaypoint {
    return {
      speed: isSet(object.speed) ? globalThis.Number(object.speed) : 0,
      maxPathSpeed: isSet(object.maxPathSpeed) ? globalThis.Number(object.maxPathSpeed) : 0,
      position: isSet(object.position) ? Vector3dPb.fromJSON(object.position) : undefined,
      uuid: isSet(object.uuid) ? Uuid.fromJSON(object.uuid) : undefined,
    };
  },

  toJSON(message: MovementWaypoint): unknown {
    const obj: any = {};
    if (message.speed !== 0) {
      obj.speed = message.speed;
    }
    if (message.maxPathSpeed !== 0) {
      obj.maxPathSpeed = message.maxPathSpeed;
    }
    if (message.position !== undefined) {
      obj.position = Vector3dPb.toJSON(message.position);
    }
    if (message.uuid !== undefined) {
      obj.uuid = Uuid.toJSON(message.uuid);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MovementWaypoint>, I>>(base?: I): MovementWaypoint {
    return MovementWaypoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MovementWaypoint>, I>>(object: I): MovementWaypoint {
    const message = createBaseMovementWaypoint();
    message.speed = object.speed ?? 0;
    message.maxPathSpeed = object.maxPathSpeed ?? 0;
    message.position = (object.position !== undefined && object.position !== null)
      ? Vector3dPb.fromPartial(object.position)
      : undefined;
    message.uuid = (object.uuid !== undefined && object.uuid !== null) ? Uuid.fromPartial(object.uuid) : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
